import React, { useContext } from 'react';
import { AppContext } from '@thd-nucleus/app-render';
import { Route, Routes, ScrollToTop } from '@thd-olt-component-react/router';
import { Error } from './pages/Error';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ({ serverPages }) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route exact path={routes.rebateCenter.path} element={<routes.rebateCenter.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {};

App.defaultProps = {};
